(() => {
  var __defProp = Object.defineProperty;
  var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
  var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);

  // scripts/settings/responsive.ts
  var RESPONSIVE_SIZES = {
    xxsmall: 375,
    xsmall: 480,
    small: 750,
    medium: 1100,
    large: 1350,
    xlarge: 1650,
    xxlarge: 2e3
  };
  var RESPONSIVE_DEFINITIONS = Object.fromEntries(
    Object.entries(RESPONSIVE_SIZES).map(([k, v]) => [k, `${v}px`])
  );
  var responsiveMediaAbove = (definition) => {
    if (typeof window === "undefined") return false;
    return window.innerWidth >= RESPONSIVE_SIZES[definition];
  };

  // scripts/tools/classes.ts
  var CLASS_OPEN = "is-open";

  // scripts/objects/accordion/AccordionSlide.ts
  var SELECTOR_SUMMARY = "[data-accordion-title]";
  var SELECTOR_CONTENT = "[data-accordion-body]";
  var AccordionSlide = class {
    constructor(el) {
      __publicField(this, "el");
      __publicField(this, "summary");
      __publicField(this, "content");
      __publicField(this, "animation");
      __publicField(this, "isClosing");
      __publicField(this, "isExpanding");
      __publicField(this, "animationSpeed", 400);
      this.el = el;
      this.summary = el.querySelector(SELECTOR_SUMMARY);
      this.content = el.querySelector(SELECTOR_CONTENT);
      this.animation = null;
      this.isClosing = false;
      this.isExpanding = false;
    }
    onClick(e) {
      if (e) e.preventDefault();
      this.el.style.overflow = "hidden";
      if (this.isClosing || !this.el.open) {
        this.open();
      } else if (this.isExpanding || this.el.open) {
        this.shrink();
      }
    }
    shrink() {
      if (!this.summary) return;
      this.isClosing = true;
      const startHeight = `${this.el.offsetHeight}px`;
      const endHeight = `${this.summary.offsetHeight}px`;
      if (this.animation) {
        this.animation.cancel();
      }
      this.animation = this.el.animate({
        height: [startHeight, endHeight]
      }, {
        duration: this.animationSpeed,
        easing: "ease-out"
      });
      this.animation.onfinish = () => this.onAnimationFinish(false);
      this.animation.oncancel = () => this.isClosing = false;
    }
    open() {
      this.el.style.height = `${this.el.offsetHeight}px`;
      this.el.open = true;
      window.requestAnimationFrame(() => this.expand());
    }
    expand() {
      if (!this.summary || !this.content) return;
      this.isExpanding = true;
      const startHeight = `${this.el.offsetHeight}px`;
      const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;
      if (this.animation) {
        this.animation.cancel();
      }
      this.animation = this.el.animate({
        height: [startHeight, endHeight]
      }, {
        duration: this.animationSpeed,
        easing: "ease-out"
      });
      this.animation.onfinish = () => this.onAnimationFinish(true);
      this.animation.oncancel = () => this.isExpanding = false;
    }
    onAnimationFinish(open) {
      this.el.open = open;
      this.animation = null;
      this.isClosing = false;
      this.isExpanding = false;
      this.el.style.height = this.el.style.overflow = "";
    }
  };

  // scripts/objects/accordion/Accordion.ts
  var SELECTOR_SLIDE = "[data-accordion-slide]";
  var Accordion = class {
    constructor(container, disableSize) {
      __publicField(this, "container");
      __publicField(this, "accordionSlideElements", null);
      __publicField(this, "accordionSlides", []);
      __publicField(this, "disableSize", null);
      this.container = container;
      this.accordionSlideElements = Array.from(container.querySelectorAll(SELECTOR_SLIDE));
      if (disableSize) this.disableSize = disableSize;
      this.attachEvents();
    }
    openAccordion() {
      if (!this.accordionSlideElements) return;
      if (this.container.classList.contains(CLASS_OPEN)) return;
      this.container.classList.add(CLASS_OPEN);
      this.accordionSlideElements.forEach((element) => element.setAttribute("open", "open"));
    }
    closeAccordion() {
      if (!this.accordionSlideElements) return;
      if (!this.container.classList.contains(CLASS_OPEN)) return;
      this.container.classList.remove(CLASS_OPEN);
      this.accordionSlideElements.forEach((element) => element.removeAttribute("open"));
    }
    closeActiveSlides(e, activeSlide) {
      if (!this.accordionSlides || this.accordionSlides.length == 0) return;
      this.accordionSlides.forEach((slide) => {
        if (slide.el == activeSlide || !slide.el.open) return;
        slide.onClick(e);
      });
    }
    onCLick(e, index) {
      if (!this.accordionSlides || this.accordionSlides.length == 0) return;
      if (this.disableSize && responsiveMediaAbove(this.disableSize)) return;
      const slide = this.accordionSlides[index];
      if (!slide) return;
      this.closeActiveSlides(e, slide.el);
      slide.onClick(e);
    }
    attachEvents() {
      if (this.accordionSlideElements && this.accordionSlideElements.length > 0) {
        this.accordionSlideElements.forEach((slideElement, i) => {
          const newSlide = new AccordionSlide(slideElement);
          this.accordionSlides.push(newSlide);
          const slideSummary = slideElement.querySelector(SELECTOR_SUMMARY);
          if (slideSummary) {
            slideSummary.addEventListener("click", (e) => this.onCLick(e, i));
          }
        });
      }
    }
    detachEvents() {
      if (this.accordionSlideElements && this.accordionSlideElements.length > 0) {
        this.accordionSlideElements.forEach((slideElement, i) => {
          const slideSummary = slideElement.querySelector(SELECTOR_SUMMARY);
          if (slideSummary) {
            slideSummary.removeEventListener("click", (e) => this.onCLick(e, i));
          }
        });
      }
    }
  };

  // scripts/sections/faq.ts
  var SELECTOR_CONTAINER = "[data-accordions]";
  document.querySelectorAll(SELECTOR_CONTAINER).forEach((container) => {
    new Accordion(container);
  });
})();
